module.exports = __webpack_public_path__ + "finance.ea8b3e4839ee71088066.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/finance/webfont/finance.svg
// module id = ../../../../../src/assets/fonts/line-icons-pro/finance/webfont/finance.svg
// module chunks = styles